import http from '../../store/services/http-common';
import { queryKeys } from '../queryKeys';

export const SUPPORT_UNREAD_POLL_MS = 30000;

export async function fetchSupportUnreadCount() {
  const { data } = await http.get('/support/unread-count');
  return Number(data?.data?.unread_count ?? 0);
}

export async function fetchSupportThread(afterId) {
  const { data } = await http.get('/support/conversation', {
    params: { after_id: afterId || undefined, mark_read: 1 },
  });
  return data?.data ?? { conversation: null, messages: [] };
}

export const supportUnreadCountQueryOptions = (enabled = true) => ({
  queryKey: queryKeys.support.unreadCount(),
  queryFn: fetchSupportUnreadCount,
  refetchInterval: SUPPORT_UNREAD_POLL_MS,
  staleTime: SUPPORT_UNREAD_POLL_MS,
  enabled,
});
